import * as React from "react";
import { Redirect } from "react-router-dom";
import SortableTbl from "react-sort-search-table";
import Loader from 'react-loader';
import { toast, ToastContainer} from 'react-toastify';
import {Button,Col, Input, Row} from 'reactstrap';

import FormModal from '../../../../components/Admin/FormModal/FormModal';
import FormFieldClass from '../../../../components/Admin/FormModal/FormFieldClass';
import Navbar from '../../../../components/CustomNav/CustomNav.Component';
import withServices  from '../../../../HOCs/withServices';
import { Wrapper, Content , ContentRow} from './ListCourses.styles'

interface IProps {
    services?: any;
    location?: any;
    match?: any;
    history?: any;
}
  
interface IState {
    toLogin: boolean;
    loaded: boolean;
    data: any;
    selectedLesson: string;
    isNavigate: boolean;
    destination: string;
}

class ListCourses extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
    
        this.state = {
          destination: '',
          toLogin: false,
          loaded: true,
          isNavigate: false,
          data: {},
          selectedLesson: '',
        };
    
        this.onLogout = this.onLogout.bind(this);
        this.onGoBack = this.onGoBack.bind(this);
        this.goToEdit = this.goToEdit.bind(this);
        this.onGoToCreate = this.onGoToCreate.bind(this);
        this.delete = this.delete.bind(this);
        this.courseSubmit = this.courseSubmit.bind(this);
        this.courseToggle = this.courseToggle.bind(this);
        this.allocateToggle = this.allocateToggle.bind(this);
        this.allocateSubmit = this.allocateSubmit.bind(this);
    }

    public onGoBack() {
        const dest = this.props.services.currentBaseUrl + 'home/';
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public onGoToCreate() {
        const dest = this.props.services.currentBaseUrl + 'interactions_creator';
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public onLogout() {
        this.setState({ toLogin: true });
    }

    public courseToggle() {
        const data = this.state.data
        data.courseModal = !data.courseModal;
        this.setState({
            data
         });
    }

    public allocateToggle() {
        const data = this.state.data
        data.allocateModal = !data.allocateModal;
        this.setState({
            data
         });
    }


    public async goToEdit(row) {
        // console.log(row);
        // const dest = this.props.services.currentBaseUrl + 'courses/' + row.rowData.id
        
        // console.log(dest)
        
        // this.setState({
        //     isNavigate: true,
        //     destination: dest
        // })
        const { services: {currentBaseUrl}, history} = this.props;
        history.push(`${currentBaseUrl}new_courses/${row.rowData.id}`);
    }

    public async delete(row) {
        console.log(row.rowData.id);

        const retVal = confirm("Do you want to continue ?");
    
        if(retVal === true) {
                  console.log('delete accepted');
                  const res = await this.props.services.adminAPI.deleteItemGeneral('courses', row.rowData.id);
                  if (res.ok) {
                    const coursesRes = await this.props.services.adminAPI.getCourses();
                  
                    if(coursesRes.ok) {
                        const collections = coursesRes.data.courses;

                        const data = this.state.data;

                        data.collections = collections;

                        this.setState({data});

                    }
                    
                }
                  return true;
        } else {
            console.log('delete canceled')
            return false;
        }
    }

    public customTD = props =>{
        return (
          <td>
            {/*tslint:disable-next-line jsx-no-lambda*/}
            <button style={{margin: '3px'}} className="blue-button view-more-data table-action" onClick={() => this.goToEdit(props)}>Edit</button>

            {/*tslint:disable-next-line jsx-no-lambda*/}
            <button style={{margin: '3px'}} className="blue-button view-more-data table-action" onClick={() => this.delete(props)}>Delete</button>
          </td>
        );
    } 

    public async componentDidMount() {
        const {
            match,
            history,
            location,
            services: { isUserLoggedIn, adminAPI, currentUserID },
        } = this.props;

        if (!isUserLoggedIn) { this.setState({ toLogin: true }); }

        const { params: { id: InteractionID } } = match;

        const assetCollectionsDataKey = ["id", "Title", "Description", "Created", "Creator","delete"];
        
        const assetCollectionsThead = ["ID", "Name", "Description", "Date", "Creator", "Action"];

        const courseFormFields = [
            {
                id: 'Name',
                name: 'Name',
                type: 'text',
                placeholder: 'Enter Name',
                required: true
            },
            {
                id: 'Description',
                name: 'Description',
                type: 'text',
                placeholder: 'Enter Description',
                required: true
            }
        ] as FormFieldClass[];


        const allocateFormFields = [
            {
                id: 'User',
                name: 'User',
                type: 'text',
                placeholder: 'Enter User ID',
                required: true
            },
            {
                id: 'Course',
                name: 'Course',
                type: 'text',
                placeholder: 'Enter Course ID',
                required: true
            }
        ] as FormFieldClass[];

        const courseFormValues = {
            Description: '',
            User: currentUserID,
            Name: '',
        }

        const allocateFormValues = {
            User: '',
            Course: '',
        }

        const assetCollectionsRes = await adminAPI.getCourses();

        if (assetCollectionsRes.ok) {
            
            const collections = assetCollectionsRes.data.courses;

            this.setState(
                {
                     data: {
                        courseModal: false,
                        allocateModal: false,
                        allocateFormFields,
                        allocateFormValues,
                        collections,
                        courseFormFields,
                        courseFormValues,
                        loaded: true,
                        collectionsdatakey: assetCollectionsDataKey,
                        collectionsthead: assetCollectionsThead
                     }
                }
            )
        } else {
            toast.error('Error fetching interaction details!');
        }
    }

    public async courseSubmit(e) {

        e.preventDefault();

        this.setState({
            loaded: false
         });

        const item = this.state.data.courseFormValues;

        const res = await this.props.services.adminAPI.createItemGeneral('courses', item);

        if (res.ok) {
            this.courseToggle();

            const coursesRes = await this.props.services.adminAPI.getCourses();
            
            if(coursesRes.ok) {
                const data = this.state.data;

                data.collections = coursesRes.data.courses;
            
                this.setState({
                    data
                 });
            }
        }
        else{
            toast.error('Error creating item!');
        }

        this.setState({
            loaded: true
        });
    }

    public async allocateSubmit(e) {

        e.preventDefault();

        this.setState({
            loaded: false
         });

        const item = this.state.data.allocateFormValues;

        const res = await this.props.services.adminAPI.manualLearnerCourseAllocate(item.User, item.Course);

        if (res.ok) {
            this.allocateToggle();
            
               toast.success('Learner allocated to course successfully!');
            
        }
        else{
            toast.error('Error creating item!');
        }

        this.setState({
            loaded: true
        });
    }

    public render() {
        const {data} = this.state;
    
        if (this.state.toLogin) {
          return <Redirect to="/login" />;
        }

        if (this.state.isNavigate) {
            return <Redirect to={this.state.destination} />;
          }
    
        if (Object.keys(data).length === 0) {
          return <Loader color="#acff24" />;
        }
 
        return (
            <Wrapper>
              <ToastContainer/>
              <Navbar logoutParent={this.onLogout} />
              <Content>
                <ContentRow className="single-col">
                  <p className="go-back" onClick={this.onGoBack}>&lt; Back</p>
                </ContentRow>
              </Content>

              <Content>
                <Button onClick={this.courseToggle}>Add New</Button>

                <Button onClick={this.allocateToggle} style={{marginLeft: '5px', marginRight: '3px'}}>Allocate Course</Button>

                <SortableTbl
                    tblData={data.collections}
                    tHead={data.collectionsthead}
                    dKey={data.collectionsdatakey}
                    customTd={[
                            { custd: this.customTD, keyItem: "edit", sortable: false },
                            { custd: this.customTD, keyItem: "delete", sortable: false }
                        ]}
                    defaultCSS={false}
                />

              </Content>

              <ContentRow>
            
                    <FormModal 
                        visible={data.courseModal}
                        toggle={this.courseToggle}
                        formsubmit={this.courseSubmit}
                        formfields = {data.courseFormFields}
                        values={data.courseFormValues}
                        isbusy={!this.state.loaded}
                    />

                    <FormModal 
                        visible={data.allocateModal}
                        toggle={this.allocateToggle}
                        formsubmit={this.allocateSubmit}
                        formfields = {data.allocateFormFields}
                        values={data.allocateFormValues}
                        isbusy={!this.state.loaded}
                    />
                    
                </ContentRow>

              
              </Wrapper>
        );

    }

}

export default withServices(ListCourses);


// WEBPACK FOOTER //
// ./src/pages/Admin/Courses/ListCourses/ListCourses.tsx